import {SwiperSlide} from "swiper/react";
import {Navigation} from "swiper";
import errorImg from "@PUBLIC/P/images/ico/ico_nodata.png";
import {SyntheticEvent} from "react";
import {SlideProps} from "@FRAMEWORK/ui/types/d";
import {ProductDetailSlider, ProductDetailSlideImg} from "@COMPONENTS/style/slide";

interface Props extends SlideProps {
	data: {
		item: string;
		text?: string;
	}[];
}

const ProductDetailSlide = ({data}: Props) => {
	const imageOnError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
		e.currentTarget.src = errorImg;
		e.currentTarget.className = "img-error";
	};

	return (
		<ProductDetailSlider slidesPerView={3} spaceBetween={15} navigation={true} modules={[Navigation]}>
			{data.map((v, inx) => (
				<SwiperSlide key={`${v.item}-${inx}`}>
					<ProductDetailSlideImg>
						<img src={v.item} alt={v.text ? v.text : v.item} onError={imageOnError} />
					</ProductDetailSlideImg>
				</SwiperSlide>
			))}
		</ProductDetailSlider>
	);
};

export default ProductDetailSlide;
